import { HttpClient, HttpRequest, HttpEventType } from '@angular/common/http';
import { AppConfig } from 'src/app/app.config';
import { Subject } from 'rxjs';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../../app.config";
var UploadService = /** @class */ (function () {
    function UploadService(http, config) {
        this.http = http;
        this.config = config;
    }
    UploadService.prototype.getDownloadLink = function (uploadConfig) {
        return this.config.getConfig("apiEndpoint") + "/download/" + uploadConfig.uploadType + "/" + uploadConfig.id;
    };
    UploadService.prototype.upload = function (files, uploadConfig) {
        var _this = this;
        var status = {};
        files.forEach(function (file) {
            var formData = new FormData();
            formData.append('file', file, file.name);
            formData.append("id", uploadConfig.id + "");
            formData.append("type", uploadConfig.uploadType);
            formData.append("originalFilename", uploadConfig.originalFilename);
            formData.append("contentType", uploadConfig.contentType);
            var req = new HttpRequest('POST', _this.config.getConfig("apiEndpoint") + "/upload", formData, {
                reportProgress: true
            });
            var progress = new Subject();
            _this.http.request(req).subscribe(function (event) {
                console.log(event);
                if (event.type === HttpEventType.UploadProgress) {
                    // calculate the progress percentage
                    var percentDone = Math.round(100 * event.loaded / event.total);
                    // pass the percentage into the progress-stream
                    progress.next(percentDone);
                }
                else if (event.type === HttpEventType.ResponseHeader) {
                    if (event.status == 200)
                        progress.complete();
                    else
                        progress.error("");
                }
            }, function (error) {
                progress.error(error);
            });
            // Save every progress-observable in a map of all observables
            status[file.name] = {
                progress: progress.asObservable()
            };
        });
        // return the map of progress.observables
        return status;
    };
    UploadService.prototype.delete = function (uploadConfig) {
        return this.http.delete(this.config.getConfig("apiEndpoint") + "/upload/" + uploadConfig.uploadType + "/" + uploadConfig.id);
    };
    UploadService.prototype.get = function (uploadConfig) {
        return this.http.get(this.config.getConfig("apiEndpoint") + "/upload/" + uploadConfig.uploadType + "/" + uploadConfig.id);
    };
    UploadService.prototype.download = function (uploadConfig) {
        return this.http.get(this.config.getConfig("apiEndpoint") + "/download/" + uploadConfig.uploadType + "/" + uploadConfig.id, { responseType: "blob" });
    };
    UploadService.ngInjectableDef = i0.defineInjectable({ factory: function UploadService_Factory() { return new UploadService(i0.inject(i1.HttpClient), i0.inject(i2.AppConfig)); }, token: UploadService, providedIn: "root" });
    return UploadService;
}());
export { UploadService };
